/**
 * author zhang.yingyu
 * createTime 2019-05-13
 **/
angular.module("tenantShareManuscriptModule",[])
.controller("tenantShareManuscriptCtrl",['$scope', '$q', '$modal', '$state', 'trsHttpService', 'globleParamsSet', 'modalDialog', 'trsspliceString', function($scope, $q, $modal, $state, trsHttpService, globleParamsSet, modalDialog, trsspliceString) {
    initStatus();
    initData();
    /**
     * [initStatus 初始化状态]
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.page = {
            "CURRPAGE": 1,
            "PAGESIZE": 20,
            "ITEMCOUNT": 0,
            "PAGECOUNT": 1,
        };
        $scope.status = {
            params: {
                serviceid: "mlf_cooperationgroup",
                methodname: "querryGroups",
                CURRPAGE: $scope.page.CURRPAGE,
                PAGESIZE: $scope.page.PAGESIZE,
            },
            copyCurrPage: 1,
        };
        $scope.data = {
            items: [],
            selectedArray: []
        };
    }
    /**
     * [initData 初始化数据]
     * @return {[type]} [description]
     */
    function initData() {
        requestData();
    }
    /**
     * [requestData description]请求数据
     * @return {[type]} [description]
     */
    function requestData() {
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.status.params, 'get').then(function(data) {
            $scope.data.items = data.DATA;
            $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
            $scope.page.PAGESIZE = data.PAGER.PAGESIZE;
            $scope.data.selectedArray = [];
        });
    };
    /**
     * [createNewCooperationGroup description]新建合作组
     * @return {[type]} [description]
     */
    $scope.createNewCooperationGroup=function(){
        $state.go("manageconfig.sysmanage.cooperationgroup",{maxsortnum:$scope.page.ITEMCOUNT},{reload:"manageconfig.sysmanage.cooperationgroup"});
    };
    /**
     * [edit description]编辑数据
     * @return {[type]} [description]
     */
    $scope.edit=function(item){
        $state.go("manageconfig.sysmanage.cooperationgroup",{objectid:item.COOPERATIONGROUPID,maxsortnum:$scope.page.ITEMCOUNT},{reload:"manageconfig.sysmanage.cooperationgroup"});
    };
    /**
     * [fullTextSearch description]检索数据
     * @return {[type]} [description]
     */
    $scope.fullTextSearch=function(){
        $scope.status.params.GROUPNAME=$scope.keywords;
        $scope.status.copyCurrPage = 1;
        requestData();
    };
    /**
     * [delete description]删除数据
     * @return {[type]} [description]
     */
    $scope.delete=function(type,item){
        var groupIds;
        if(type==="deleteAll"){
            groupIds=trsspliceString.spliceString($scope.data.selectedArray , "COOPERATIONGROUPID", ",");
        }else{
            groupIds=item.COOPERATIONGROUPID;
        }
        modalDialog.alertType('选中项目将被删除，确定继续？', "", "ask", true, function () {
            deleteTenantCoorData(groupIds).then(function(data){
                if(data.ISSUCCESS==="true"){
                    modalDialog.alertType('删除成功', '', 'success', false, function() {
                        requestData();
                    });
                }
            });
        });
    };
    /**
     * [delete description]删除数据
     * @return {[type]} [description]
     */
    function deleteTenantCoorData(groupIds){
        var deffer = $q.defer();
        var params = {
            serviceid: "mlf_cooperationgroup",
            methodname: "deleteGroup",
            groupIds:groupIds
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
            deffer.resolve(data);
        });
        return deffer.promise;
    };
    /**
     * [switchBen description单选]
     */
    $scope.switchBtn = function (item,index) {
        modalDialog.alertType(item.GROUPSTATUS==='1'?'所选项目将被停用,确定继续?':'所选项目将被启用,确定继续?', "", "ask", true, function () {
            isEnableTenant(item).then(function(data){
                if(data.ISSUCCESS==="true"){
                    modalDialog.alertType(data.DETAIL, '', 'success', false, function() {
                        $scope.data.items[index].GROUPSTATUS=item.GROUPSTATUS=='0'?'1':'0';
                    });
                }
            });
        });
    };
    /**
     * [isEnableTenant description]是否启用
     * @return {[type]} [description]
     */
    function isEnableTenant(item){
        var deffer = $q.defer();
        var params = {
            serviceid: "mlf_cooperationgroup",
            methodname: item.GROUPSTATUS==="1"?"stopGroupById":"openGroupById",
            ObjectId:item.COOPERATIONGROUPID
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
            deffer.resolve(data);
        });
        return deffer.promise;
    };
    /**
     * [selectAll description] 列表全选按钮
     * @return {[type]} [description]
     */
    $scope.selectAll = function() {
        $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
    };
    /**
     * [selectDoc description] 列表单选按钮
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    $scope.selectDoc = function(item) {
        var index = $scope.data.selectedArray.indexOf(item);
        if (index < 0) {
            $scope.data.selectedArray.push(item);
        } else {
            $scope.data.selectedArray.splice(index, 1);
        }
    };
    /** [selectPageNum description] 每页显示的数据数量
     */
    $scope.selectPageNum = function() {
        $scope.status.copyCurrPage = 1;
        requestData();
    };
    /**
     * [pageChanged description] 下一页 页面改变调取数据
     * @return {[type]} [description]
     */
    $scope.pageChanged = function() {
        $scope.status.copyCurrPage = $scope.page.CURRPAGE;
        requestData();
    };
    /**
     * [jumpToPage description] 跳转页
     * @return {[type]} [description]
     */
    $scope.jumpToPage = function() {
        if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
            $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
        }
        $scope.page.CURRPAGE = $scope.status.copyCurrPage;
        requestData();
    };
}]);